<template>
  <grid columns="2" columns-s="1">
    <c>
      <input class="w-100 h-100" type="text" :placeholder="roomIdPlaceholder" v-model="botRiotList.riot_room_id" />
    </c>
    <c span="1">
      <v-autocomplete
        v-model="selectedUser"
        @update-items="loadSuggestionUsers"
        :items="suggestedUsers"
        :get-label="getLabel"
        :component-item="template"
        @item-clicked="addUser"
        @keyup.enter.native="addSelectedUser"
        :placeholder="placeholder"
        :auto-select-one-item="false"
        :min-len="0"
      />
    </c>
  </grid>
</template>
<script>
import { mapState } from "vuex";
import UserTemplate from "@/templates/UserTemplate.vue";
import cache from "../../../store/cache";
import utilsMessengers from "@/common/utils.messengers";
export default {
  props: ["botRiotList"],
  components: {},
  computed: {
    ...mapState("boards", { activeBoard: "active" }),
    roomIdPlaceholder() {
      if (this.botRiotList) {
        if (utilsMessengers.is(this.botRiotList.messenger_type, utilsMessengers.telegram)) {
          return "id группы telegram";
        }
      }
      return "id комнаты riot";
    },
    placeholder() {
      if (!this.botRiotList || !this.botRiotList.user_id) return "Пользователь по умолчанию";

      return this.getLabel(cache.users.byId(this.botRiotList.user_id));
    }
  },
  data() {
    return {
      selectedUser: null,
      suggestedUsers: [],
      template: UserTemplate
    };
  },
  methods: {
    loadSuggestionUsers(text) {
      if (!text) {
        this.suggestedUsers = [];
        return;
      }

      let usersToTest = this.activeBoard.users.map((u) => u);
      if (!usersToTest.find((u) => u.id == this.activeBoard.author)) {
        const creator = cache.users.byId(this.activeBoard.author);
        if (creator) {
          usersToTest.push(creator);
        }
      }

      usersToTest = usersToTest.filter((u) => {
        if (u.riot_name) {
          if (u.riot_name.toLowerCase().indexOf(text.toLowerCase()) > -1) {
            return true;
          }
        }
        if (u.name) {
          if (u.name.toLowerCase().indexOf(text.toLowerCase()) > -1) {
            return true;
          }
        }

        return false;
      });

      usersToTest.push({
        id: -666,
        name: "По умолчанию"
      });

      this.suggestedUsers = usersToTest;
    },
    getLabel(user) {
      if (!user) return "";
      if (user.riot_name) return user.name + " " + user.riot_name;
      return user.name;
    },
    addSelectedUser() {
      this.addUser(this.selectedUser);
    },
    addUser(user) {
      if (!user) {
        return;
      }

      this.selectedUser = null;
      this.suggestedUsers = [];
      this.botRiotList.user_id = user.id == -666 ? null : user.id;
    }
  }
};
</script>
<style lang="postcss"></style>
